// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

$(function(){


	// init variable
	// --------------------------------------------------------------- //
	var $win = $(window),
		winHeight = $win.height();
	$win.resize(function(){
		winHeight = $win.height();
	});


	// pc header
	// --------------------------------------------------------------- //
	// var h = $('.header-main').height();
	var h = 120;
	var header_h = 320;

//	if ( $('body').hasClass('home') ) {
//		header_h = $('.p-front-main').height();
//	} else {
//		header_h = $('.header').height();
//	}

	$(window).on('load scroll resize', function() {
		var scl = $win.scrollTop();
		if( scl >= (header_h - h) ) {
			$('.header').addClass('header--small');
		} else {
			$('.header').removeClass('header--small');
		}
	} );



	/* front main visual
	 ----------------------------------------------------------------- */
//	$(window).on('load', function() {
//		$('.p-front-main').addClass('p-front-main--start');
//		$('.p-front-main-bg').addClass('p-front-main-bg--start');
//	} );


	// sp hamberger
	// --------------------------------------------------------------- //
	$('.js-header-icon').click(function() {
		$(this).toggleClass('header-icon__link--close');
		$('.header-menu__bg').toggleClass('header-menu__bg--active');
		$('.js-header-menu-body').toggleClass('header-menu__body--active');
	} );

	$('.js-menu-link').click(function() {
		$('.js-header-icon').toggleClass('header-icon__link--close');
		$('.header-menu__bg').toggleClass('header-menu__bg--active');
		$('.header-menu__body').toggleClass('header-menu__body--active');
	} );

	$('.header-menu__bg').click(function() {
		$('.js-header-icon').toggleClass('header-icon__link--close');
		$('.header-menu__bg').toggleClass('header-menu__bg--active');
		$('.header-menu__body').toggleClass('header-menu__body--active');
	} );


	// anchor
	// --------------------------------------------------------------- //
	$('a[href^="#"]:not(.js-anchor-disable)').click(function() {
		var speed = 400;
		var href= $(this).attr('href');
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		//position = position - 68;
		if (matchMedia('(min-width: 960px)').matches) {
			position = position - 48;
		}
		$('body, html').animate({scrollTop:position}, speed, 'swing');

		return false;
	});


	// page top
	// --------------------------------------------------------------- //
	$('.js-page-top').click(function(){
		$('body, html').animate({
			scrollTop: 0
		}, 400);

		return false;
	});


	/* js toggle
	 ----------------------------------------------------------------- */
	$('.js-toggle').click(function() {
		var $id = $(this).data('toggle');
		$(this).toggleClass('c-toggle-button--close');
		$('[data-target="' + $id + '"]').slideToggle('fast');

		$(this).parent('p').remove();
		return false;
	} );


	/* faq toggle
	 ----------------------------------------------------------------- */
	$('.js-faq-toggle').click(function() {
		var $id = $(this).data('toggle');
		$(this).find('.c-faq-toggle-icon').toggleClass('c-faq-toggle-icon--close');
		$('[data-target="' + $id + '"]').slideToggle('fast');
		return false;
	} );


	// form privacy check
	// --------------------------------------------------------------- //
	if ( $('.js-privacy').length ) {
		privacyFlag();
	}

	$('.js-privacy').click(function() {
		privacyFlag();
	} );

	function privacyFlag() {
		if ( $('.js-privacy').prop('checked') == true ) {
			$('.js-submit').prop('disabled', false);
		} else {
			$('.js-submit').prop('disabled', true);
		}
	}

});


